// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1d0TY","infoBtn":"quickbooks_infoBtn__LWQ2G","formBox":"quickbooks_formBox__21MG7","formFooter":"quickbooks_formFooter__1U8Qs"};